import { Modal, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';

export const ConfirmModal = ({ show, onHide, title, children, handleCancel, variantCancel = "secondary", textCancel = "Cancelar", disabledCancel = false, handleConfirm, variantConfirm = "danger", textConfirm="Confirmar", disabledConfirm = false }) => {
    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                { children }
            </Modal.Body>
            <Modal.Footer>
                <Button variant={variantCancel} onClick={handleCancel} disabled={disabledCancel}>
                    {textCancel}
                </Button>
                <Button variant={variantConfirm} onClick={handleConfirm} disabled={disabledConfirm}>
                    {textConfirm}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
ConfirmModal.propTypes = {
    show: PropTypes.bool,
    onHide: PropTypes.func,
    title: PropTypes.string,
    handleCancel: PropTypes.func,
    variantCancel: PropTypes.string,
    textCancel: PropTypes.string,
    disabledCancel: PropTypes.bool,
    handleConfirm: PropTypes.func,
    variantConfirm: PropTypes.string,
    textConfirm: PropTypes.string,
    disabledConfirm: PropTypes.bool,
    children: PropTypes.node
}